// Engine sound-control protocol (single-base-slot).
// SET_ALLOWED_SOUNDS restricts which engine sounds may play: pass [SoundTypes.BACKGROUND_SOUND]
// to allow only the background music (used while Ultra Play is active, so its own sounds sit on
// top), or 'all' to restore everything. The base engine is still implementing the handler — this
// is the agreed protocol, so the message is forward-compatible (a no-op until then).
export const SoundMessages = {
    SET_ALLOWED_SOUNDS: 'setAllowedSounds',
} as const

export type SoundMessages = (typeof SoundMessages)[keyof typeof SoundMessages]

export const SoundTypes = {
    BACKGROUND_SOUND: 'backgroundSound',
} as const

export type SoundTypes = (typeof SoundTypes)[keyof typeof SoundTypes]
